module.exports = __webpack_public_path__ + "img/equal.ec5ab7a6.svg";